const validEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
const list = value => Array.isArray(value) ? value : [];
export function filterCompaniesForConsultation(rows, search = '', filters = {}) {
  const term = search.trim().toLocaleLowerCase('pt-BR');
  return rows.filter(company => {
    if (company?.sourceMetadata?.trash?.deletedAt || company?.sourceMetadata?.systemCode === 'NO_COMPANY') return false;
    if (term && ![company.corporateName, company.tradeName, company.cnpj, company.city, company.state,
      ...list(company.phones), ...list(company.emails)]
      .some(value => String(value || '').toLocaleLowerCase('pt-BR').includes(term))) return false;
    if (filters.status && company.status !== filters.status) return false;
    if (filters.city && company.city !== filters.city) return false;
    if (filters.state && company.state !== filters.state) return false;
    if (filters.sendSlip && String(Boolean(company.sendSlip)) !== filters.sendSlip) return false;
    const preferences = new Map(list(company.sourceMetadata?.invoiceEmailPreferences)
      .map(row => [String(row?.email || '').trim().toLowerCase(), row?.sendInvoice !== false]));
    const configured = list(company.emails).some(email => validEmail(email) && preferences.get(String(email).trim().toLowerCase()) !== false);
    return !filters.invoiceEmail || (filters.invoiceEmail === 'true' ? configured : !configured);
  });
}
